const isEditableService = element => element.isEditable && element.isVisible

export const additionalServicesCopyWithExtraFields = offer => {
  const additionalServicesCopy = [...offer.extraServicesList]

  const indexedRateModelEditableServices = {}

  const rateModelEditableServices =
    offer.rateModel.extraServicesList.filter(isEditableService) ?? []

  rateModelEditableServices.forEach(service => {
    indexedRateModelEditableServices[service.id] = service
  })

  const offerEditableServices = additionalServicesCopy.filter(isEditableService) ?? []

  offerEditableServices.forEach(service => {
    const rateModelService = indexedRateModelEditableServices[service.id] ?? {}

    if (!service.isDynamic) {
      service.stdMinValueApproved = rateModelService.stdMinValueApproved
      service.stdMaxValueApproved = rateModelService.stdMaxValueApproved

      service.stdMaxValue = rateModelService.stdMaxValue
    }

    if (service.id === 'COMBUSTIBLE') {
      // Fuel bonus percentage must be freely editable from 0 to 100 in 5% steps
      // regardless of committed deliveries. Approval thresholds remain enforced
      // via stdMinValueApproved/stdMaxValueApproved and the lock/unlock behavior.
      service.changeRate = 5
      service.stdMinValue = 0
      service.stdMaxValue = 100
    }

    if (service.type === 'PERCENTAGE') {
      service.minValueApproved = rateModelService.minValueApproved
      service.maxValueApproved = rateModelService.maxValueApproved
      service.initialMinValue = rateModelService.minValue
      service.initialMaxValue = rateModelService.maxValue
    }
  })

  return additionalServicesCopy
}
